import { Box, List, ListItemButton } from "@mui/material";
import Collapse from "@mui/material/Collapse/Collapse";

interface Props {
  onClick: () => void;
  openSubmenu: boolean;
  text: string;
  icon: string;
}
const Submenu = ({ onClick, openSubmenu, text, icon }: Props) => {
  return (
    <Collapse in={openSubmenu} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <ListItemButton sx={{ pl: 4 }} onClick={onClick}>
          <Box component={"i"} className={icon} sx={{ mr: 1 }} />
          {text}
        </ListItemButton>
      </List>
    </Collapse>
  );
};

export default Submenu;
